import useStrings from './useStrings';
import Helpers from "../commons/helpers";
import UserService from "../services/identity/user.service";
import UserGroupService from '../services/identity/userGroup.service';

import { ICodename } from '../commons/interfaces';
import { RoleHelpers } from '../commons/roleHelpers';
import { ActionRequest, Status } from "../constants/enums";
import { useCommonComponentContext } from "../providers/CommonComponentProvider";



const useContainerStaff = () => {
    const Strings = useStrings();

    const {
        onError,
        onSuccess,
        onShowLoading,
        onHideLoading,
    } = useCommonComponentContext();

    const isPermissionCheckGroupManager = (dataRole: ICodename[], newRoles: string[]) => {
        const listRoleType: number[] = [];

        dataRole.forEach(el => {
            if (newRoles.includes(`${el.code}`)) {
                listRoleType.push(Number(el.detail?.roleType));
            }
        });

        const index = listRoleType.findIndex(e => (
            RoleHelpers.isOrganizationAdmin(e)
            || RoleHelpers.isOrganizationOwner(e)
            || RoleHelpers.isOrganizationGroupAdmin(e)
        ));

        return (index !== -1);
    };

    const onChangeStatusMember = (props: {
        lable?: string;
        onCallBack?: () => void;
        params: {
            id: string;
            status: number;
            clientId: string;
            organizationId: string,
        }
    }) => {
        if (Helpers.isNullOrEmpty(props.params?.status)) {
            onError(Strings.Common.ERROR);
        } else {

            const messageAlert = (props.params?.status === Status.Active)
                ? Strings.Organization.CONFIRM_IN_ACTIVE_STATUS
                : Strings.Organization.CONFIRM_ACTIVE_STATUS;

            Helpers.showConfirmAlert(messageAlert, async () => {
                try {
                    onShowLoading();

                    await UserService.updateStatus({
                        allService: false,
                        userId: props.params?.id,
                        clientId: props.params?.clientId,
                        organizationId: props.params?.organizationId,
                        isActive: (props.params?.status === Status.Active) ? false : true
                    });

                    const messageSuccess = (props.params?.status === Status.Active)
                        ? Strings.Organization.IN_ACTIVE_STATUS_SUCCESS
                        : Strings.Organization.ACTIVE_STATUS_SUCCESS;

                    onSuccess(messageSuccess);

                    props.onCallBack && props.onCallBack();
                } catch (error: any) {
                    const e = Helpers.renderExceptionError(error);
                    onError(e);
                } finally {
                    onHideLoading();
                }
            });
        }
    };

    const getDetailUserGroup = async (req: {
        userId: string,
        clientId: string,
        organizationId: string,
    }) => {
        try {
            onShowLoading();

            let groupUserTemp: any[] = [];

            const result = await UserGroupService.getDetail(req);

            [...result || []].forEach(item => {
                groupUserTemp.push({
                    id: item.id,
                    groupId: item.groupId,
                    manager: item.manager,
                    default: item.default,
                    userTitle: item.userTitle,
                    action: ActionRequest.Update,
                });
            });

            return groupUserTemp;
        } catch (error) {
            return [];
        } finally {
            onHideLoading();
        }
    };

    return {
        getDetailUserGroup,
        onChangeStatusMember,
        isPermissionCheckGroupManager,
    };
}

export default useContainerStaff;